import { Modal } from '@services/MarppleShop/renderApp/components/atoms/Modal/Modal.ts';
import { FundingModalController } from '@services/MarppleShop/renderApp/components/cells/funding/FundingModalController.ts';
import { FundingModalBody } from '@services/MarppleShop/renderApp/components/cells/funding/FundingModalBody.ts';
import klass from './FundingModal.module.scss';
import { SupporterRankingsResponse } from '@services/MarppleShop/features/Funding';
import { ButtonAction } from '@services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';

export interface FundingModalProps {
  product_id: number;
  supporters: SupporterRankingsResponse;
  is_mobile?: boolean;
}

export class FundingModalFactory {
  static create(props: FundingModalProps): Modal {
    const fundingModalController = new FundingModalController(props);

    return new Modal({
      size: 'large',
      title: fundingModalController.texts.modal.title,
      title_options: {
        title_align: props.is_mobile ? 'center' : 'left',
        title_klass: klass.modal_title,
        use_left_blank_space: !!props.is_mobile,
      },
      body: new FundingModalBody({ fundingModalController }),
      body_klass: klass.modal_body,
      isOpen: false,
      full_width: true,
      full_body_height: true,
      footer: props.is_mobile
        ? new ButtonAction({
            size: 'large',
            label: '닫기',
            type: 'line',
          })
        : undefined,
    });
  }
}
